"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowFileConverter.
 * @author OPt
 */


var WindowFileConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowFileConverter, _DataObjectConverter_);

  function WindowFileConverter() {
    _classCallCheck(this, WindowFileConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowFileConverter).apply(this, arguments));
  }

  return WindowFileConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowFileConverter = WindowFileConverter;